import { Link, useLocation, useNavigate } from "react-router";
import './ChapterNav.scss'
import { Menu, MenuItem, MenuRadioGroup } from "@szhsin/react-menu";
import { MenuArrow } from "../../../Comps/Menu/MenuDownArrow";
export interface ChapterNavItem{
    title:string,
    path:string,
    element:JSX.Element
    isExercise?:boolean
}
export function ChapterNav(props:{path:string, subPaths:ChapterNavItem[]}){
    const fullPath:string = useLocation().pathname
    const navigate = useNavigate();

    const ChapterLink = (props:{basePath:string, chapterNav:ChapterNavItem, index:number}) => {
        const getLinkClass = (section:string) => {
            if((fullPath === props.basePath) && props.index === 0){
                return 'current'
            }
            return( (fullPath.includes(section) ? 'current' : '' ) )
        }
        return(
            <Link to={props.basePath + "/" + props.chapterNav.path}>
                <button className={getLinkClass(props.chapterNav.path)}>{props.chapterNav.title}</button>
            </Link>  
        )
    }
    const ChapterLinks = () => {
        if(props.subPaths.length === 1){return null}
        const chapterLinks:JSX.Element[] = []
        props.subPaths.forEach((nav:ChapterNavItem, index:number)=>{
            if(nav.isExercise){ return }
            chapterLinks.push(<ChapterLink key={props.path + index} index={index} chapterNav={nav} basePath={props.path}/>)
        })
        return <>{chapterLinks}</>
    }
    const ExerciseMenu = () => {
        const getActiveExerciseTitle = () => {
            const activeNavItem:ChapterNavItem|undefined = props.subPaths.find((navItem:ChapterNavItem)=>{
                return (fullPath.includes(navItem.path))
            })
            if(activeNavItem?.isExercise){return activeNavItem.title}
            return ''
        }
        const exerciseMenuItems:ChapterNavItem[] = props.subPaths.filter((navItem:ChapterNavItem)=>{
            return (navItem.isExercise === true)
        })
        let activeExerciseTitle:string = getActiveExerciseTitle()
        if(activeExerciseTitle !== ''){activeExerciseTitle = ' : ' + getActiveExerciseTitle() }
        const getButtonClasses = () => {
            if(activeExerciseTitle !== ''){return 'selected'}
            return ''
        }
        const navTo = (value:string) => {
            navigate(props.path + '/' + value)
        }
        const getCurrentExercisePath = () => {
            const activeNavItem:ChapterNavItem|undefined = props.subPaths.find((navItem:ChapterNavItem)=>{
                return (fullPath.includes(navItem.path))
            })
            if(activeNavItem?.isExercise){return activeNavItem.path}
            return '' 
        }
        const getMenu = () => {
            if(exerciseMenuItems.length === 0){return null}
            return(
                <Menu menuButton={<button className={getButtonClasses()} type={'button'}>Exercises {activeExerciseTitle} <MenuArrow/></button>}>
                    <MenuRadioGroup value={getCurrentExercisePath()} onRadioChange={(e:any)=>{navTo(e.value)}}>{
                        exerciseMenuItems.map((navItem:ChapterNavItem, index:number)=>{
                            return <MenuItem key={index} type={'radio'} value={navItem.path}>{navItem.title}</MenuItem>
                        })  
                    }</MenuRadioGroup>
                </Menu>
            )
        }
        return(getMenu())
    }
    return(
        <div className={'chapter-nav'}>
            <ChapterLinks/>
            <ExerciseMenu/>
        </div>
    )
}